var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from "react";
import ReactDiv100vh from "react-div-100vh";
import { getYoutubeId, getVimeoId, getMatterportId } from "@wrstudios/utils";
import Header from "./Header";
import Map from "./Map";
import Photos from "./Photos";
import Tour from "./Tour";
import { Container } from "./styled/fullscreen-media";

function FullscreenMedia(_a) {
  var street = _a.street,
      city = _a.city,
      state = _a.state,
      zip = _a.zip,
      markerLat = _a.markerLat,
      markerLon = _a.markerLon,
      markerColor = _a.markerColor,
      controlColor = _a.controlColor,
      _b = _a.photos,
      photos = _b === void 0 ? [] : _b,
      env = _a.env,
      casJwt = _a.casJwt,
      mapboxApiToken = _a.mapboxApiToken,
      virtualTour = _a.virtualTour,
      mapOptions = _a.mapOptions,
      backgroundColor = _a.backgroundColor,
      _c = _a.initialTab,
      initialTab = _c === void 0 ? "map" : _c,
      initialSlideIndex = _a.initialSlideIndex,
      exitIcon = _a.exitIcon,
      _d = _a.onExit,
      onExit = _d === void 0 ? function () {} : _d,
      _e = _a.useFullscreen,
      useFullscreen = _e === void 0 ? true : _e,
      props = __rest(_a, ["street", "city", "state", "zip", "markerLat", "markerLon", "markerColor", "controlColor", "photos", "env", "casJwt", "mapboxApiToken", "virtualTour", "mapOptions", "backgroundColor", "initialTab", "initialSlideIndex", "exitIcon", "onExit", "useFullscreen"]);

  var youtubeId = getYoutubeId(virtualTour || "");
  var vimeoId = getVimeoId(virtualTour || "");
  var matterportId = getMatterportId(virtualTour || "");
  var hasVirtualTour = Boolean(youtubeId || vimeoId || matterportId);
  var hasPhotos = !!photos.length;

  var _f = useState(initialTab === "tour" ? hasVirtualTour ? initialTab : "map" : initialTab === "photos" ? hasPhotos ? initialTab : "map" : "map"),
      activeTab = _f[0],
      setActiveTab = _f[1];

  var _g = useState(false),
      showSatellite = _g[0],
      setShowSatellite = _g[1];

  var container = React.createElement(Container, __assign({}, props), React.createElement(Header, {
    street: street,
    city: city,
    state: state,
    zip: zip,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    controlColor: controlColor,
    virtualTour: virtualTour,
    exitIcon: exitIcon,
    onExit: onExit,
    hasPhotos: hasPhotos,
    hasVirtualTour: hasVirtualTour
  }), activeTab === "map" && React.createElement(Map, {
    street: street,
    city: city,
    state: state,
    zip: zip,
    markerLat: markerLat,
    markerLon: markerLon,
    markerColor: markerColor,
    env: env,
    casJwt: casJwt,
    mapboxApiToken: mapboxApiToken,
    mapOptions: mapOptions,
    backgroundColor: backgroundColor,
    showSatellite: showSatellite,
    setShowSatellite: setShowSatellite
  }), activeTab === "photos" && React.createElement(Photos, {
    photos: photos,
    initialIndex: initialSlideIndex,
    backgroundColor: backgroundColor
  }), activeTab === "tour" && React.createElement(Tour, {
    virtualTour: virtualTour,
    backgroundColor: backgroundColor
  }));

  if (useFullscreen) {
    container = React.createElement(ReactDiv100vh, null, container);
  }

  return container;
}

export default FullscreenMedia;